import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Grid, Row, Col } from "react-bootstrap";

class SignupCustomerThanks extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="content">
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Grid fluid>
                                    <Row>
                                        <div
                                            className="col-md-8"
                                            style={{
                                                margin: "0 auto",
                                                float: "none"
                                            }}
                                        >
                                            <Col md={12}>
                                                <div className="flexElem flexResponsive halfCols alignFlexCenter">
                                                    <div className="fieldWithIcon">
                                                        <h3
                                                            style={{
                                                                fontWeight:
                                                                    "500"
                                                            }}
                                                        >Customer Signup</h3>
                                                    </div>
                                                </div>
                                                <hr />
                                            </Col>

                                            <Col md={12} style={{ lineHeight: 2.5, paddingBottom: 15 }}>
                                                Thank you for signing up.<br />One of the system admin will review your request and soon get back to you via email.
                                            </Col>
                                            <Col md={12}>
                                                <Link to={"/"}><button type='button' className="customBtn btnBlack m-sm">Go Back</button></Link>
                                            </Col>
                                        </div>
                                    </Row>
                                </Grid>
                            </Col>
                        </Row>
                    </Grid></div></React.Fragment>
        )
    };
}

export default SignupCustomerThanks;


// WEBPACK FOOTER //
// ./src/components/Admin/Users/SignupCustomerThanks.jsx